import { render, staticRenderFns } from "./Checkouted.vue?vue&type=template&id=f8c23588&"
import script from "./Checkouted.vue?vue&type=script&lang=js&"
export * from "./Checkouted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports